var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTellIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.048,
    height: 26.999,
    viewBox: "0 0 27.048 26.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2355",
    "data-name": "Rectangle 2355",
    width: 27.049,
    height: 26.999,
    fill: "#99abb3",
    stroke: "#99abb3",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10512",
    "data-name": "Group 10512",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10511",
    "data-name": "Group 10511",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27863",
    "data-name": "Path 27863",
    d: "M20.253,17.931a2.693,2.693,0,0,0-3.824,0l-1.3,1.3a23.551,23.551,0,0,1-4.057-3.257,24.208,24.208,0,0,1-3.257-4.057l1.3-1.3a2.693,2.693,0,0,0,0-3.824L6.572,4.255a2.635,2.635,0,0,0-1.9-.792,2.717,2.717,0,0,0-1.917.792L1.534,5.468A5.732,5.732,0,0,0,.059,10.191c.285,3.374,2.5,7.431,5.909,10.852s7.515,5.622,10.889,5.946a6.6,6.6,0,0,0,.754,0,5.464,5.464,0,0,0,3.968-1.475l1.214-1.223a2.717,2.717,0,0,0,.792-1.917,2.635,2.635,0,0,0-.792-1.9Zm1.27,5.088L20.3,24.233a4.107,4.107,0,0,1-3.294.9c-2.924-.248-6.649-2.319-9.723-5.4s-5.145-6.77-5.425-9.694a4.072,4.072,0,0,1,.9-3.294l1.27-1.223a.906.906,0,0,1,1.274,0L7.851,8.1a.906.906,0,0,1,0,1.27l-1.8,1.8a.894.894,0,0,0-.145,1.087A24.647,24.647,0,0,0,9.8,17.27a24.673,24.673,0,0,0,5.023,3.9.9.9,0,0,0,1.087-.145l1.8-1.8a.9.9,0,0,1,1.269,0l2.545,2.544a.924.924,0,0,1,.261.643.884.884,0,0,1-.261.608M23.088,3.95A13.409,13.409,0,0,0,13.553,0a.9.9,0,0,0,0,1.8,11.7,11.7,0,0,1,11.7,11.793.9.9,0,1,0,1.8,0,13.41,13.41,0,0,0-3.96-9.643",
    transform: "translate(0 0)",
    fill: "#99abb3",
    stroke: "#99abb3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27864",
    "data-name": "Path 27864",
    d: "M15.765,8.149a5.421,5.421,0,0,1,1.593,3.879.9.9,0,1,0,1.8,0,7.2,7.2,0,0,0-7.2-7.291.9.9,0,1,0,0,1.8,5.417,5.417,0,0,1,3.8,1.612",
    transform: "translate(2.207 0.945)",
    fill: "#99abb3",
    stroke: "#99abb3",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTellIcon);
export default __webpack_public_path__ + "static/media/tell_icon.6953c52af8c770e113b4019353bcaced.svg";
export { ForwardRef as ReactComponent };